import * as React from "react";

function SvgIcons8Group(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M10 7c-2.758 0-5 2.242-5 5s2.242 5 5 5 5-2.242 5-5-2.242-5-5-5zm0 10c-4.96 0-9 4.035-9 9h18c0-.98-.18-1.93-.469-2.813a5.53 5.53 0 01.344-.656A5.46 5.46 0 0123.5 20c3.05 0 5.5 2.45 5.5 5.5v.5h2v-.5c0-2.902-1.668-5.441-4.094-6.688A5.498 5.498 0 0029 14.5c0-3.027-2.473-5.5-5.5-5.5a5.513 5.513 0 00-5.5 5.5c0 1.758.832 3.336 2.125 4.344A7.496 7.496 0 0017.5 21.03 9.005 9.005 0 0010 17zm13.5-6c1.945 0 3.5 1.555 3.5 3.5S25.445 18 23.5 18a3.484 3.484 0 01-3.5-3.5c0-1.945 1.555-3.5 3.5-3.5z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Group);
